import { StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, fontFamily, radii, spacing, type } from '~/ui/tokens';
import { getAmenityIcon } from '~/lib/amenityIcons';

interface AmenityChipProps {
  label: string;
}

export function AmenityChip({ label }: AmenityChipProps) {
  return (
    <View style={styles.chip}>
      <Ionicons name={getAmenityIcon(label)} size={15} color={colors.brand} />
      <Text style={styles.label}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing(0.75),
    backgroundColor: colors.skyTint,
    borderRadius: radii.full,
    paddingVertical: spacing(0.75),
    paddingHorizontal: spacing(1.5),
  },
  label: {
    fontFamily: fontFamily.medium,
    ...type.bodyRegular,
    color: colors.ink,
  },
});
